import { LocationDto } from "./Location";

export interface LocationGroup {
    id?: number;
    projectId: number;
    name: string;
    status?: boolean;
    remark?: string;
    isDeleted?: boolean;
    alertThreshold?: number;
    alarmThreshold?: number;
    actionThreshold?: number;
}

export interface LocationGroupDto {
    id: number;
    projectId: number;
    projectName: string;
    name: string;
    status: boolean;
    remark?: string;
    isDeleted?: boolean;
    alertThreshold?: number;
    alarmThreshold?: number;
    actionThreshold?: number;
    locations: LocationDto[];
}

export interface ILocationGroupError {
    projectId: string;
    name: string;
    status: string;
}

export class LocationGroupErrorValue implements ILocationGroupError {
    projectId: string = "";
    name: string = "";
    status: string = "";
}

export interface LocationGroupForm extends Partial<LocationGroup> {
}

export class LocationGroupFormValue implements LocationGroupForm {
    id?: number | undefined;
    projectId?: number | undefined = 0;
    name: string = "";
    status?: boolean = false;
    remark?: string = "";
    isDeleted?: boolean = false;
    alertThreshold?: number = undefined;
    alarmThreshold?: number = undefined;
    actionThreshold?: number = undefined;

    constructor(init?: LocationGroupForm) {
        Object.assign(this, init);
    }
}

